import { PITCH_RECOMMENDATION } from "@/constants/audioQuality";
import { PitchRecommendation } from "@/types/defs/audioQuality/pitchRecommendation";

// Sweet spot takes priority, including when the recommendation sits on a window edge.
export const getPitchRecommendationStatus = (
  pitchRecommendation: PitchRecommendation,
  currentPitch: number
): {
  label: (typeof PITCH_RECOMMENDATION)[keyof typeof PITCH_RECOMMENDATION]["label"];
  dotColor: (typeof PITCH_RECOMMENDATION)[keyof typeof PITCH_RECOMMENDATION]["dotColor"];
} | null => {
  if (pitchRecommendation === null) {
    return null;
  }
  const { recommendedPitch, pitchShiftWindow } = pitchRecommendation;

  if (currentPitch === recommendedPitch) {
    return PITCH_RECOMMENDATION.sweetSpot;
  }

  if (currentPitch < pitchShiftWindow.min) {
    return PITCH_RECOMMENDATION.likelyTooLow;
  }
  if (currentPitch > pitchShiftWindow.max) {
    return PITCH_RECOMMENDATION.likelyTooHigh;
  }

  // Inside the window: pick the edge on the current side and measure how close we are to the sweet spot as a fraction of that half. ≤ 0.5 (inner half) → Great; > 0.5 (outer half toward the edge) → Okay.
  const pitchWindowEdge =
    currentPitch < recommendedPitch ?
      pitchShiftWindow.min
    : pitchShiftWindow.max;
  const distanceFromSweetSpotToEdge = Math.abs(
    recommendedPitch - pitchWindowEdge
  );
  const distanceFromSweetSpotNormalized =
    distanceFromSweetSpotToEdge <= 0 ? 0 : (
      Math.abs(currentPitch - recommendedPitch) / distanceFromSweetSpotToEdge
    );
  return distanceFromSweetSpotNormalized <= 0.5 ?
      PITCH_RECOMMENDATION.great
    : PITCH_RECOMMENDATION.okay;
};
